export class Country{
    countryId:any;
    countryName:string;
}